import { useApi } from './api'
import { useStorage } from '@/composables/useStorage'

export const apiUserInfo = () => {
   const { api } = useApi()
   const { getUserInfo } = useStorage()

   const obter = async () => {
       ;
      if (getUserInfo == null || getUserInfo == undefined) {
         const { data } = await api.get('/usuarios/info')
         return data
      }
   }

   return {
      obter
   }
}
